import PersonalizationCardImage from "./components/PersonalizationCardImage";
import PersonalizationInput from "./components/PersonalizationInput";
import PersonalizationTextarea from "./components/PersonalizationTextarea";

export default function PersonalizationNextGlobalHealthImprovementsIntro({getError,overallHealths,setOverallHealths}) {
    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <PersonalizationCardImage src={'/assets/survey_personalization_screens/global_health_intro.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Section Title'}
            value={overallHealths?.nextTitle}
            setValue={(value) => setOverallHealths({nextTitle:value})}
            errorMessage={getError('overallHealths','nextTitle')}
        />

        <PersonalizationTextarea
            title={'Description'}
            value={overallHealths?.nextDesc}
            setValue={(value) => setOverallHealths({nextDesc:value})}
            errorMessage={getError('overallHealths','nextDesc')}
        />

        <PersonalizationInput
            title={'Video Link (Optional)'}
            value={overallHealths?.nextVideoUrl}
            setValue={(value) => setOverallHealths({nextVideoUrl:value})}
            errorMessage={getError('overallHealths','nextVideoUrl')}
        />
    </div>
}
